import { getRuntimeEnv, isRuntimeDev } from "./runtimeEnv";

/**
 * Controls how much technical detail error pages and the error boundary show.
 *
 * - **full** — Vite dev server + localhost only: stacks, component traces, raw payloads.
 * - **verbose** — Vite dev (e.g. LAN IP) or localhost with production build: message + context, no full stacks.
 * - **minimal** — Production builds on public hosts: user-safe copy only.
 *
 * Optional override: `VITE_ERROR_VERBOSITY=verbose|full|minimal` in `.env`.
 */
export function getSiteErrorVerbosity() {
  const override = String(getRuntimeEnv("VITE_ERROR_VERBOSITY", "")).toLowerCase().trim();
  if (override === "full" || override === "verbose" || override === "minimal") {
    return override;
  }

  if (typeof window === "undefined") {
    return "minimal";
  }

  const host = window.location.hostname || "";
  const isLocalHost =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]";

  const isViteDev = isRuntimeDev();

  if (isViteDev && isLocalHost) {
    return "full";
  }
  if (isViteDev || isLocalHost) {
    return "verbose";
  }
  return "minimal";
}

export function shouldShowErrorStacks() {
  return getSiteErrorVerbosity() === "full";
}

export function shouldShowErrorDebugPanel() {
  const v = getSiteErrorVerbosity();
  return v === "full" || v === "verbose";
}
